import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.5 15.9844C14.1569 15.9844 15.5 14.6412 15.5 12.9844C15.5 11.3275 14.1569 9.98438 12.5 9.98438C10.8431 9.98438 9.5 11.3275 9.5 12.9844C9.5 14.6412 10.8431 15.9844 12.5 15.9844Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M2.5 13.8658V12.1058C2.5 11.0658 3.35 10.2058 4.4 10.2058C6.21 10.2058 6.95 8.92578 6.04 7.35578C5.52 6.45578 5.83 5.28578 6.74 4.76578L8.47 3.77578C9.26 3.30578 10.28 3.58578 10.75 4.37578L10.86 4.56578C11.76 6.13578 13.24 6.13578 14.15 4.56578L14.26 4.37578C14.73 3.58578 15.75 3.30578 16.54 3.77578L18.27 4.76578C19.18 5.28578 19.49 6.45578 18.97 7.35578C18.06 8.92578 18.8 10.2058 20.61 10.2058C21.65 10.2058 22.51 11.0558 22.51 12.1058V13.8658C22.51 14.9058 21.66 15.7658 20.61 15.7658C18.8 15.7658 18.06 17.0458 18.97 18.6158C19.49 19.5258 19.18 20.6858 18.27 21.2058L16.54 22.1958C15.75 22.6658 14.73 22.3858 14.26 21.5958L14.15 21.4058C13.25 19.8358 11.77 19.8358 10.86 21.4058L10.75 21.5958C10.28 22.3858 9.26 22.6658 8.47 22.1958L6.74 21.2058C5.83 20.6858 5.52 19.5158 6.04 18.6158C6.95 17.0458 6.21 15.7658 4.4 15.7658C3.35 15.7658 2.5 14.9058 2.5 13.8658Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }